import { useContext } from "react";
import { AppContext } from "../Theme";
import Sidebar from "../components/sidebar/sidebar";
import Navbar from "../components/navbar/navbar";
import Subcards from "../components/Subcards/Subcards";
import "../main.css";

export default function Subscriptions() {
	const { darkmode, toggleMode } = useContext(AppContext);

	return (
		<>
			<div className="sidebar-component">
				<Sidebar mode={darkmode} toggleMode={toggleMode} />
			</div>
			<div className="navbar-component">
				<Navbar mode={darkmode} username="Nexcare" />
			</div>
			<Subcards mode={darkmode} />
		</>
	);
}
